// Belt Builder CTA — inline banner on product pages linking to /pages/build-your-belt.
// Appears above the variant picker. Auto-injects, no theme editing required.
(function () {
  const BUILDER_URL = '/pages/build-your-belt';

  function isProductPage() {
    return /^\/products\/[^/?#]+/.test(location.pathname);
  }

  // Show only for belt-like products. Skip leather sheets, hardware-only, etc.
  function isBeltLikeProduct() {
    const titleEl = document.querySelector('h1, .product-title, .product__title');
    if (!titleEl) return false;
    const t = (titleEl.textContent || '').toLowerCase();
    if (/(belt|strap)/.test(t)) return true;
    // Fallback: if variant picker has Color option → likely a belt
    return Boolean(document.querySelector('variant-picker'));
  }

  function buildBanner() {
    const wrap = document.createElement('div');
    wrap.className = 'lsm-builder-cta-wrap';

    const a = document.createElement('a');
    a.className = 'lsm-builder-cta';
    a.href = BUILDER_URL;
    a.innerHTML = '<div class="lsm-builder-cta__inner">' +
      '<div class="lsm-builder-cta__icon">🛠️</div>' +
      '<div class="lsm-builder-cta__text">' +
        '<div class="lsm-builder-cta__title">Need more customization?</div>' +
        '<div class="lsm-builder-cta__sub">Use our <strong>Belt Builder</strong> — pick width, color, buckle style, hardware finish and buckle color in one place.</div>' +
      '</div>' +
      '<div class="lsm-builder-cta__arrow">→</div>' +
    '</div>';
    wrap.appendChild(a);

    return wrap;
  }

  function injectStyles() {
    if (document.getElementById('lsm-builder-cta-styles')) return;
    const s = document.createElement('style');
    s.id = 'lsm-builder-cta-styles';
    s.textContent = `
      .lsm-builder-cta {
        display: block !important;
        text-decoration: none !important;
        color: #1a1a1a !important;
        background: linear-gradient(135deg, #fff8e6, #fff) !important;
        border: 1.5px solid #e8c500 !important;
        border-radius: 10px !important;
        padding: 1rem 1.25rem !important;
        margin: 1rem 0 !important;
        transition: all 0.2s ease !important;
      }
      .lsm-builder-cta:hover {
        background: linear-gradient(135deg, #fff0c4, #fffae0) !important;
        border-color: #d4b500 !important;
        transform: translateY(-1px);
        text-decoration: none !important;
      }
      .lsm-builder-cta * { color: #1a1a1a !important; }
      .lsm-builder-cta__inner {
        display: flex;
        align-items: center;
        gap: 1rem;
      }
      .lsm-builder-cta__icon { font-size: 2rem; flex-shrink: 0; }
      .lsm-builder-cta__text { flex: 1; }
      .lsm-builder-cta__title {
        font-weight: 700;
        font-size: 1rem;
        margin-bottom: 0.15rem;
        color: #1a1a1a !important;
      }
      .lsm-builder-cta__sub {
        font-size: 0.85rem;
        color: #333 !important;
        line-height: 1.4;
      }
      .lsm-builder-cta__sub strong { color: #8a6f00 !important; font-weight: 700; }
      .lsm-builder-cta__arrow {
        font-size: 1.5rem;
        color: #8a6f00 !important;
        flex-shrink: 0;
        font-weight: 700;
      }
      @media (max-width: 600px) {
        .lsm-builder-cta__inner { gap: 0.75rem; }
        .lsm-builder-cta__icon { font-size: 1.6rem; }
        .lsm-builder-cta__title { font-size: 0.95rem; }
        .lsm-builder-cta__sub { font-size: 0.78rem; }
      }
    `;
    document.head.appendChild(s);
  }

  function attach() {
    if (!isProductPage() || !isBeltLikeProduct()) return;
    if (document.querySelector('.lsm-builder-cta')) return; // already injected

    injectStyles();
    const banner = buildBanner();

    // Try to insert above variant-picker; fallback to add-to-cart button area
    const picker = document.querySelector('variant-picker');
    if (picker) {
      picker.parentElement.insertBefore(banner, picker);
      return;
    }
    const buyBtn = document.querySelector('.product-form, [data-product-form], product-form-component');
    if (buyBtn) {
      buyBtn.parentElement.insertBefore(banner, buyBtn);
      return;
    }
    // Last resort: insert after H1
    const title = document.querySelector('h1');
    if (title) title.parentElement.insertBefore(banner, title.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
  document.addEventListener('shopify:section:load', attach);
  // Re-inject on variant changes (when picker rerenders)
  new MutationObserver(() => attach()).observe(document.body, { childList: true, subtree: true });
})();
